function Research2021() {

    return (
      <>
        <div className="ml-10 mt-5">
          <div className="flex">
            <div className="w-16">2021</div>

            <div className="w-full">
                <div className="flex">
                    <div className="w-16">Jul</div>
                    <div className="w-full">
                        <p><a href="https://www.ms.u-tokyo.ac.jp/~yasuyuki/crest-seminar.htm" target='_blank'>“Toric code induced by bicommutative Hopf algebras.”</a></p>
                        <p>CREST Research Seminar on Theoretical studies of topological phases of matter, online</p>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </>
    );
  }
  
  export default Research2021;